import type { TEnoughtArchivariusFields } from './api/models';

export const FORM_CHANGED_SUBSCRIPTION = { values: true, errors: true, active: true } as const;

export const FORM_SUBMITTING_SUBSCRIPTION = { submitting: true } as const;

export const DEBOUNCE_DELAY = 1000;

/** Набор полей архивариуса */
export const archivariusFields = new Set<keyof TEnoughtArchivariusFields>([
    'firstName',
    'lastName',
    'middleName',
    'sex',
    'phone',
    'birthDate',
    'email',
]);
